import { render, staticRenderFns } from "./PageNotFoundContent.vue?vue&type=template&id=63b69e92"
import script from "./PageNotFoundContent.vue?vue&type=script&lang=ts"
export * from "./PageNotFoundContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports